import type { DisplayedMotion } from '../boards/runtime/motion';
import type { TableModel } from '../model/table';
import type { MotionEvent } from '../motion/diff';
export const TABLE_ACTIVITY = 'table-displayed-activity';
const motions = new WeakMap<Element, { motion: DisplayedMotion; time: number }>();
export function clearActivity(root: Element | null) { if (root) motions.delete(root); }
export function publishActivity(root: Element, motion: DisplayedMotion) {
  motions.set(root, { motion, time: performance.now() });
  root.dispatchEvent(new CustomEvent(TABLE_ACTIVITY, { detail: motion }));
}
export function recentActivity(root: Element | null): DisplayedMotion | null {
  const entry = root ? motions.get(root) : null;
  return entry && performance.now() - entry.time < 1500 ? entry.motion : null;
}
/** Use public changes only; never infer hidden identities from count changes. */
export function activityTab(events: MotionEvent[], zones: Map<string, Set<string>>, table: TableModel, previous: TableModel): string | null {
  const scores = new Map<string, number>();
  const add = (zone: string | null, score: number) => { if (zone) for (const [key, ids] of zones) if (ids.has(zone)) scores.set(key, (scores.get(key) ?? 0) + score); };
  for (const event of events) {
    if (event.type === 'counter') continue; // HUD/player counters do not steal a board action's focus.
    if ('id' in event) {
      const object = table.objects.get(event.id) ?? previous.objects.get(event.id);
      if (object) add(object.zoneId, object.ref || object.at ? 10 : 2);
    } else if (event.type === 'count') add(event.to ?? event.from, 1);
  }
  let best: string | null = null, score = 0;
  for (const key of zones.keys()) if ((scores.get(key) ?? 0) > score) { best = key; score = scores.get(key)!; }
  return best;
}
